import { render, staticRenderFns } from "./Page-full-height.vue?vue&type=template&id=184fd493&"
import script from "./Page-full-height.vue?vue&type=script&lang=js&"
export * from "./Page-full-height.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports